import Logger, { LOG_LEVELS } from '../utils/logger';
import CLIENT from '../utils/restClient';

export const MODULE_NAME = 'SALESANDPURCHASELEDGERS_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
    return MODULE_NAME + '.' + name;
}

const LOAD_LEDGERS = namespaced('LOAD_LEDGERS');
const LOAD_LEDGERS_OK = namespaced('LOAD_LEDGERS_OK');
const LOAD_LEDGERS_FAIL = namespaced('LOAD_LEDGERS_FAIL');
const EXPORT_ALL = namespaced('EXPORT_ALL');
const EXPORT_ALL_OK = namespaced('EXPORT_ALL_OK');
const EXPORT_ALL_FAIL = namespaced('EXPORT_ALL_FAIL');

export const ACTION_TYPES = {
    LOAD_LEDGERS,
    LOAD_LEDGERS_OK,
    LOAD_LEDGERS_FAIL,
    EXPORT_ALL,
    EXPORT_ALL_OK,
    EXPORT_ALL_FAIL
}

export const updateSubStateFromAction = (state = { data: undefined, loading: false, error: null }, action) => {
    switch (action.type) {
        case LOAD_LEDGERS:
            return Object.assign({}, state, { showToast: false, loading: true, data:null, error: null });
        case LOAD_LEDGERS_OK:
            return Object.assign({}, state, { showToast: false, data: action.response, loading: false, error: null });
        case LOAD_LEDGERS_FAIL:
            return Object.assign({}, state, { showToast: false, data: null, loading: false, error: action.error });
        case EXPORT_ALL:
            return Object.assign({}, state, { showToast: false, error: null });
        case EXPORT_ALL_OK:
            return Object.assign({}, state, { showToast: true, error: null, exportResponse: action.response });
        case EXPORT_ALL_FAIL:
            return Object.assign({}, state, { showToast: false, error: action.error });
        default:
            return state;
    }
}

const API = {
    doLoadLedgers: (params) => {
        log.debug("doLoadLedgers()");
        return async (dispatch) => {
            dispatch({ type: LOAD_LEDGERS });
            try {
                const response = await CLIENT.getSalesAndPurchaseLedger(params);
                if(Array.isArray(response)) {
                    dispatch({ type: LOAD_LEDGERS_FAIL, error: response });
                } else {
                    if(response.message) {
                        dispatch({ type: LOAD_LEDGERS_FAIL, error: response });
                    } else {
                        dispatch({ type: LOAD_LEDGERS_OK, response: {...response, isEngTranslated: params.translated} });
                    }
                }
            } catch (error) {
                dispatch({ type: LOAD_LEDGERS_FAIL, error: error });
            }
        };
    },
    doExportAllDataForLedger: (params) => {
        log.debug("exportAllDataForLedger()");
        return (dispatch) => {
            dispatch({type: EXPORT_ALL});
            return CLIENT.exportAllDataForLedger(params)
                .then((response) => {
                    log.debug('exportAllDataForLedger success');
                    dispatch({type: EXPORT_ALL_OK, response: response});
                })
                .catch((error) => {
                    log.debug('doExportAllDataForLedger error');
                    dispatch({type: EXPORT_ALL_FAIL, error});
                });
        };
    }
}

export default API;